import React from "react";

function CardBody({ loading, locked, city, color, catKey }) {
  if (loading) return <div className="text-[10px] uppercase tracking-widest text-[#A89C98]">Calibrating…</div>;
  if (locked) return <div className="text-[11px] text-[#A89C98]">Unlock with Solar Return or Infinity</div>;
  if (!city) return <div className="text-[11px] text-[#A89C98] italic">Signal weak.</div>;
  return (
    <div>
      <div className="font-heading text-xl leading-tight" style={{ color }} data-testid={`top-city-name-${catKey}`}>{city.city_display}</div>
      <div className="text-[10px] uppercase tracking-widest text-[#A89C98] mt-0.5">{city.country || "—"}</div>
    </div>
  );
}

export function CategoryCard({ c, city, isActive, loading, locked, onClick }) {
  const Icon = c.icon;
  return (
    <button
      type="button"
      data-testid={`top-city-btn-${c.key}`}
      onClick={onClick}
      className={`relative overflow-hidden text-left rounded-xl p-4 border transition-all ${isActive ? "border-[#C8A96E] shadow-[0_0_24px_rgba(200,169,110,0.35)]" : "border-white/10 hover:border-[#C8A96E]/60"}`}
      style={{ background: isActive ? `linear-gradient(160deg, ${c.color}22 0%, #15111A 100%)` : "rgba(255,255,255,0.02)" }}
    >
      <div className="flex items-center gap-2 mb-2">
        <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: `${c.color}22`, border: `1px solid ${c.color}88` }}>
          <Icon size={15} style={{ color: c.color }} />
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-[0.25em]" style={{ color: c.color }}>{c.label}</div>
          <div className="text-[9px] uppercase tracking-widest text-[#A89C98]">{c.sources}</div>
        </div>
      </div>
      <CardBody loading={loading} locked={locked} city={city} color={c.color} catKey={c.key} />
    </button>
  );
}
